<template>
  <div class="fixed-menu d-sm-none">
    <div class="fixed-menu-body">
      <router-link :class="item.linkClass" class="link" v-for="item in nav" :to="item.to" :key="item.title">
        <div class="icon-container">
          <i v-if="item.icon" :class="item.icon"></i>
          <img v-if="item.src" :src="item.src">
          <svg class="icon" v-if="item.symbol"><use :xlink:href="`/static/images/dashboard/sprites.svg#${item.symbol}`"/></svg>
        </div>
        <span>{{item.title}}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ['nav']
}
</script>

<style lang="scss" scoped>
@import '~scss/colors';

.fixed-menu-body {
  padding: 0;
  justify-content: space-around;
  text-align: center;
  font-size: small;
}
.link {
    flex-grow: 1;
    border-top: 5px solid rgba(0,0,0,0);
}
.link.router-link-exact-active,
.link.non-exact.router-link-active {
  border-top-color: $red;
  background: $gray-2;
}
.icon-container {
  img {
    width: 33px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pages/dashboard/MobileLeftNav.vue